/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Capabilities_TitleInputs */

const en_mcp_capabilities_title = /** @type {(inputs: Mcp_Capabilities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your reading time back`)
};

const es_mcp_capabilities_title = /** @type {(inputs: Mcp_Capabilities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupera tu tiempo de lectura`)
};

/**
* | output |
* | --- |
* | "Get your reading time back" |
*
* @param {Mcp_Capabilities_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_capabilities_title = /** @type {((inputs?: Mcp_Capabilities_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Capabilities_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_capabilities_title(inputs)
	return en_mcp_capabilities_title(inputs)
});